import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  customerId: z.string().optional(),
});

export const Route = createFileRoute("/app/admin/locations/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
